/**
 * Computes the trapeze line item's SWO/PN Summary display name from the
 * patient's weight, per the Medicare LCD L33820 threshold. Presentation-only.
 */

export const TRAPEZE_CONSOLIDATED_ITEM_NAME = "Trapeze - attached to bed";

/** True when `formItemName` is the trapeze item. */
export const isTrapezeFormItemName = (
  formItemName: string | null | undefined,
): boolean => formItemName === TRAPEZE_CONSOLIDATED_ITEM_NAME;

// Per Medicare LCD L33820: heavy-duty trapeze (E0911) for weight > 250 lbs,
// standard (E0910) otherwise. Matches _TRAPEZE_WEIGHT_THRESHOLD_LBS in
// services/orders/insert/modern_line_items.py.
const TRAPEZE_WEIGHT_THRESHOLD_LBS = 250;

/**
 * Computes the trapeze's Weight Capacity option ("Standard"/"Bariatric") from
 * patient weight, for callers that only have the facade variant (and so can't
 * read the hidden Weight Capacity option group's resolved value directly).
 */
export const getTrapezeWeightCapacityOptionName = (
  formItemName: string | null | undefined,
  patientWeight: number | null | undefined,
): string | null => {
  if (!isTrapezeFormItemName(formItemName) || patientWeight == null) {
    return null;
  }
  return patientWeight > TRAPEZE_WEIGHT_THRESHOLD_LBS
    ? "Bariatric"
    : "Standard";
};

/**
 * Strips the placeholder "Default" option once a real Weight Capacity
 * option is also present; keeps it if that's all there is.
 */
export const getTrapezeSwoDisplayOptions = (
  formItemName: string | null | undefined,
  formItemOptions: string[],
): string[] => {
  if (!isTrapezeFormItemName(formItemName)) {
    return formItemOptions;
  }
  const withoutDefault = formItemOptions.filter(
    (option) => option !== "Default",
  );
  return withoutDefault.length > 0 ? withoutDefault : formItemOptions;
};
